import React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export enum MessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}
export interface MessageProps {
  title: string;
  body: string;
  type?: MessageType;
}

export const Message = ({ title, body, type }: MessageProps) => {
  return (
    <div style={{ margin: 'auto' }}>
      <UitkLayoutFlex space="half" direction="column" alignItems="center">
        <UitkSpacing margin={{ blockend: 'one' }}>
          <UitkIcon name={type} id={type} size={UitkIconSize.EXTRA_SMALL} />
        </UitkSpacing>
        <UitkText theme="emphasis"> {title}</UitkText>
        <UitkText theme="default" size={200}>
          {body}
        </UitkText>
      </UitkLayoutFlex>
    </div>
  );
};
